import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import angular_react from '../assets/angular_react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import ai from '../assets/ai.png';
import net from '../assets/net.png';
import csharp from '../assets/csharp.png';
import raspberry from '../assets/raspberry.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';
import sorryIllustration from '../assets/sorry.gif';

import profile1 from '../assets/profile_1.png';
import profile2 from '../assets/profile_2.png';
import profile3 from '../assets/profile_3.png';
import profile4 from '../assets/profile_4.png';
// import profile5 from '../assets/profile_5.png';



import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import skFavicon from '../assets/SK_Favicon.png'
import tn from '../assets/tn.gif';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

const images= {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  angular_react,
  redux,
  sass,
  typescript,
  vue,
  ai,
  net,
  csharp,
  raspberry,
  about01,
  about02,
  about03,
  about04,
  profile1,
  profile2,
  profile3,
  profile4,
  // profile5,
  sorryIllustration,
  circle,
  logo,
  skFavicon,
  tn,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
};

export default images